import React, { useEffect, useState } from 'react';
import Navbar from "./Navbar";
import Footer from "./Footer";
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import Testimonial from "./IMGS/Testimonial.png";
import Testimonial_2 from "./IMGS/Testimonial_2.png";

const API_BASE_URL = 'https://royaleheritagefiesta.com/royaleheritagefiesta/api';

const Services = () => {
  const [showBackToTop, setShowBackToTop] = useState(false);
  const [showFloatingButtons, setShowFloatingButtons] = useState(false);
  const [activeFaq, setActiveFaq] = useState(0);
  const [formLoading, setFormLoading] = useState(false);
  const [formSuccess, setFormSuccess] = useState('');
  const [formError, setFormError] = useState('');
  const [loading, setLoading] = useState(true);
  const [content, setContent] = useState({
    hero: { title: 'Our Royal Services', subtitle: 'Experience the epitome of elegance with our signature royal experiences', button_text: 'Plan Your Royal Event' },
    services_section: { title: 'Our Premier Services', subtitle: 'Exquisite offerings that define royal elegance' },
    service1: { title: 'Royal Heritage Festia', description: 'Curated heritage experiences celebrating tradition and grandeur with royal elegance.', image: '', path: '/RoyalHeritageFiesta', features: ['Heritage Walks', 'Royal Processions', 'Cultural Performances', 'Traditional Cuisine'] },
    service2: { title: 'Royal Dinners', description: 'Exquisite fine dining experiences with royal ambiance and culinary mastery.', image: '', path: '/RoyalDinners', features: ['Michelin-Star Chefs', 'Royal Table Settings', 'Live Music', 'Premium Wine Selection'] },
    service3: { title: 'Music & Concerts', description: 'World-class performances and unforgettable musical experiences that move your soul.', image: '', path: '/MusicAndConcerts', features: ['International Artists', 'Live Orchestras', 'Acoustic Sessions', 'Sound Engineering'] },
    why_choose_us: { title: 'The Royal Heritage Advantage', subtitle: 'What makes us the premier choice for royal celebrations' },
    why_items: [
      { icon: 'bi-globe2', title: '10+ Years Excellence', description: 'Over a decade of crafting royal experiences' },
      { icon: 'bi-star', title: '500+ Royal Events', description: 'Proven track record of successful celebrations' },
      { icon: 'bi-people', title: 'Expert Team', description: 'Dedicated specialists in luxury events' },
      { icon: 'bi-globe2', title: 'Global Reach', description: 'Events across 20+ countries' }
    ],
    supporting_services: { title: 'Supporting Services', subtitle: 'Complete solutions for your royal celebration' },
    support_items: [
      { icon: 'bi-calendar-check', title: 'Event Planning', description: 'Comprehensive planning and coordination.' },
      { icon: 'bi-brush', title: 'Royal Decor', description: 'Opulent decorations reflecting royal heritage.' },
      { icon: 'bi-people', title: 'VIP Hospitality', description: 'Premium hospitality for distinguished guests.' },
      { icon: 'bi-camera-reels', title: 'Photography & Video', description: 'Professional media coverage.' },
      { icon: 'bi-shield-check', title: 'Security Services', description: 'Comprehensive security arrangements.' },
      { icon: 'bi-gem', title: 'Custom Experiences', description: 'Tailored experiences for your vision.' }
    ],
    our_process: { title: 'Our Royal Process', subtitle: 'A meticulous approach to crafting unforgettable experiences' },
    process_items: [
      { num: '01', icon: 'bi-star', title: 'Royal Consultation', desc: 'Understand your vision' },
      { num: '02', icon: 'bi-brush', title: 'Curated Planning', desc: 'Design bespoke experience' },
      { num: '03', icon: 'bi-play-circle', title: 'Royal Execution', desc: 'Flawless delivery' },
      { num: '04', icon: 'bi-star', title: 'Memorable Moments', desc: 'Creating lasting impressions' },
      { num: '05', icon: 'bi-heart', title: 'Royal Follow-up', desc: 'Ensuring satisfaction' }
    ],
    testimonials: { title: 'What Our Guests Say', subtitle: 'Experiences that speak for themselves' },
    testimonial_items: [
      { text: "The Royal Heritage Festia was absolutely magnificent! Every detail was perfect.", name: "Vikram Singh", title: "Event Attendee", img: "", rating: 5 },
      { text: "The Royal Dinners experience was beyond imagination. Truly world-class hospitality.", name: "Meera Kapoor", title: "Dinner Guest", img: "", rating: 5 },
      { text: "The concert was spectacular! Perfect acoustics and unforgettable performances.", name: "Arjun Nair", title: "Music Lover", img: "", rating: 5 }
    ],
    faq: { title: 'Frequently Asked Questions', subtitle: 'Quick answers about our royal services' },
    faq_items: [
      { question: "What is included in the Royal Heritage Festia experience?", answer: "Royal Heritage Festia includes curated heritage walks, royal processions, cultural performances, traditional cuisine, and immersive experiences." },
      { question: "How far in advance should I book a Royal Dinner?", answer: "We recommend booking Royal Dinners 3-6 months in advance." },
      { question: "Do you handle international artists for Music & Concerts?", answer: "Yes! We have partnerships with world-class international artists." },
      { question: "Can I customize the Royal Dinners menu?", answer: "Absolutely! Our culinary team works closely with you." }
    ],
    booking: { title: "Let's Create Your Royal Experience", subtitle: "Share your vision and we'll bring it to life", whatsapp_number: "919966252374", button_text: "Send Enquiry via WhatsApp" }
  });
  
  const [formData, setFormData] = useState({
    fullName: '',
    company: '',
    email: '',
    phone: '',
    eventType: 'Royal Heritage Festia',
    preferredDate: '',
    requirements: ''
  });
  
  const navigate = useNavigate();

  // Fetch services content from API
  const fetchServicesContent = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${API_BASE_URL}/get-services-content.php`);
      if (response.data.success && response.data.data) {
        const fetchedData = response.data.data;
        setContent(prev => ({
          ...prev,
          ...fetchedData,
          hero: fetchedData.hero || prev.hero,
          services_section: fetchedData.services_section || prev.services_section,
          service1: fetchedData.service1 || prev.service1,
          service2: fetchedData.service2 || prev.service2,
          service3: fetchedData.service3 || prev.service3,
          why_choose_us: fetchedData.why_choose_us || prev.why_choose_us,
          why_items: Array.isArray(fetchedData.why_items) ? fetchedData.why_items : prev.why_items,
          supporting_services: fetchedData.supporting_services || prev.supporting_services,
          support_items: Array.isArray(fetchedData.support_items) ? fetchedData.support_items : prev.support_items,
          our_process: fetchedData.our_process || prev.our_process,
          process_items: Array.isArray(fetchedData.process_items) ? fetchedData.process_items : prev.process_items,
          testimonials: fetchedData.testimonials || prev.testimonials,
          testimonial_items: Array.isArray(fetchedData.testimonial_items) ? fetchedData.testimonial_items : prev.testimonial_items,
          faq: fetchedData.faq || prev.faq,
          faq_items: Array.isArray(fetchedData.faq_items) ? fetchedData.faq_items : prev.faq_items,
          booking: fetchedData.booking || prev.booking
        }));
      }
    } catch (error) {
      console.error('Error fetching services content:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchServicesContent();
  }, []);

  useEffect(() => {
    if (window.AOS) {
      window.AOS.init({ duration: 800, once: true, offset: 50 });
    }

    const handleScroll = () => {
      setShowBackToTop(window.scrollY > 300);
      setShowFloatingButtons(window.scrollY > 500);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Build services array from API data
  const services = [
    {
      image: content.service1?.image || 'https://images.unsplash.com/photo-1711867623677-d34515fe679b?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MzF8fHJveWFsJTIwaGVyaXRhZ2V8ZW58MHx8MHx8fDA%3D',
      title: content.service1?.title || 'Royal Heritage Festia',
      description: content.service1?.description || 'Curated heritage experiences celebrating tradition and grandeur with royal elegance.',
      features: content.service1?.features || ['Heritage Walks', 'Royal Processions', 'Cultural Performances', 'Traditional Cuisine'],
      path: content.service1?.path || '/RoyalHeritageFiesta'
    },
    {
      image: content.service2?.image || 'https://images.unsplash.com/photo-1576326062417-11b7c40e8ddf?w=800&auto=format',
      title: content.service2?.title || 'Royal Dinners',
      description: content.service2?.description || 'Exquisite fine dining experiences with royal ambiance and culinary mastery.',
      features: content.service2?.features || ['Michelin-Star Chefs', 'Royal Table Settings', 'Live Music', 'Premium Wine Selection'],
      path: content.service2?.path || '/RoyalDinners'
    },
    {
      image: content.service3?.image || 'https://images.pexels.com/photos/167491/pexels-photo-167491.jpeg?auto=compress&cs=tinysrgb&w=800',
      title: content.service3?.title || 'Music & Concerts',
      description: content.service3?.description || 'World-class performances and unforgettable musical experiences that move your soul.',
      features: content.service3?.features || ['International Artists', 'Live Orchestras', 'Acoustic Sessions', 'Sound Engineering'],
      path: content.service3?.path || '/MusicAndConcerts'
    }
  ];

  // Build why choose us array from API data
  const whyChooseUs = Array.isArray(content.why_items) && content.why_items.length > 0 
    ? content.why_items 
    : [
        { icon: 'bi-globe2', title: '10+ Years Excellence', description: 'Over a decade of crafting royal experiences' },
        { icon: 'bi-star', title: '500+ Royal Events', description: 'Proven track record of successful celebrations' },
        { icon: 'bi-people', title: 'Expert Team', description: 'Dedicated specialists in luxury events' },
        { icon: 'bi-globe2', title: 'Global Reach', description: 'Events across 20+ countries' }
      ];

  // Build supporting services array from API data
  const supportingServices = Array.isArray(content.support_items) && content.support_items.length > 0
    ? content.support_items
    : [
        { icon: 'bi-calendar-check', title: 'Event Planning', description: 'Comprehensive planning and coordination.' },
        { icon: 'bi-brush', title: 'Royal Decor', description: 'Opulent decorations reflecting royal heritage.' },
        { icon: 'bi-people', title: 'VIP Hospitality', description: 'Premium hospitality for distinguished guests.' },
        { icon: 'bi-camera-reels', title: 'Photography & Video', description: 'Professional media coverage.' },
        { icon: 'bi-shield-check', title: 'Security Services', description: 'Comprehensive security arrangements.' },
        { icon: 'bi-gem', title: 'Custom Experiences', description: 'Tailored experiences for your vision.' }
      ];

  // Build process items array from API data
  const processItems = Array.isArray(content.process_items) && content.process_items.length > 0
    ? content.process_items
    : [
        { num: '01', icon: 'bi-star', title: 'Royal Consultation', desc: 'Understand your vision' },
        { num: '02', icon: 'bi-brush', title: 'Curated Planning', desc: 'Design bespoke experience' },
        { num: '03', icon: 'bi-play-circle', title: 'Royal Execution', desc: 'Flawless delivery' },
        { num: '04', icon: 'bi-star', title: 'Memorable Moments', desc: 'Creating lasting impressions' },
        { num: '05', icon: 'bi-heart', title: 'Royal Follow-up', desc: 'Ensuring satisfaction' }
      ];

  // Build testimonials array from API data
  const testimonialItems = Array.isArray(content.testimonial_items) && content.testimonial_items.length > 0
    ? content.testimonial_items.map((item, idx) => ({
        ...item,
        img: idx === 0 ? Testimonial_2 : (idx === 1 ? Testimonial : Testimonial_2)
      }))
    : [
        { text: "The Royal Heritage Festia was absolutely magnificent! Every detail was perfect.", name: "Vikram Singh", title: "Event Attendee", img: Testimonial_2, rating: 5 },
        { text: "The Royal Dinners experience was beyond imagination. Truly world-class hospitality.", name: "Meera Kapoor", title: "Dinner Guest", img: Testimonial, rating: 5 },
        { text: "The concert was spectacular! Perfect acoustics and unforgettable performances.", name: "Arjun Nair", title: "Music Lover", img: Testimonial_2, rating: 5 }
      ];

  // Build FAQ items array from API data
  const faqItems = Array.isArray(content.faq_items) && content.faq_items.length > 0
    ? content.faq_items
    : [
        { question: "What is included in the Royal Heritage Festia experience?", answer: "Royal Heritage Festia includes curated heritage walks, royal processions, cultural performances, traditional cuisine, and immersive experiences that celebrate royal traditions and grandeur." },
        { question: "How far in advance should I book a Royal Dinner?", answer: "We recommend booking Royal Dinners 3-6 months in advance to ensure availability of Michelin-star chefs, premium venues, and the perfect royal ambiance for your celebration." },
        { question: "Do you handle international artists for Music & Concerts?", answer: "Yes! We have partnerships with world-class international artists and can arrange everything from booking to technical production for spectacular musical experiences." },
        { question: "Can I customize the Royal Dinners menu?", answer: "Absolutely! Our culinary team works closely with you to create a bespoke menu that reflects your preferences, dietary requirements, and the royal theme of your event." }
      ];

  const handleServiceClick = (path) => {
    navigate(path);
  };
  
  const handleHomeClick = () => {
    navigate('/');
  };
  
  const handleBackToTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });
  
  const handleWhatsAppClick = () => {
    const phoneNumber = content.booking?.whatsapp_number || "919966252374";
    window.open(`https://wa.me/${phoneNumber}?text=Hi%20Royal%20Heritage%20Fiesta%20team,%20I%27m%20interested%20in%20your%20services.`, '_blank');
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  // Generate WhatsApp message from form data
  const generateWhatsAppMessage = (data) => {
    const message = `*ROYAL HERITAGE FIESTA - New Service Enquiry*

*Contact Information:*
Name: ${data.fullName || 'Not provided'}
Company: ${data.company || 'Not provided'}
Email: ${data.email || 'Not provided'}
Phone: ${data.phone || 'Not provided'}

*Event Information:*
Event Type: ${data.eventType || 'Not provided'}
Preferred Date: ${data.preferredDate || 'Not provided'}

*Event Requirements:*
${data.requirements || 'Not provided'}

---
*This enquiry was submitted from Royal Heritage Fiesta Services page.*`;

    return encodeURIComponent(message);
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    setFormLoading(true);
    setFormSuccess('');
    setFormError('');

    if (!formData.fullName || !formData.email || !formData.eventType || !formData.preferredDate || !formData.requirements) {
      setFormError('Please fill in all required fields marked with *');
      setFormLoading(false);
      setTimeout(() => setFormError(''), 3000);
      return;
    }

    try {
      const message = generateWhatsAppMessage(formData);
      const phoneNumber = content.booking?.whatsapp_number || "919966252374";
      const whatsappUrl = `https://wa.me/${phoneNumber}?text=${message}`;
      
      window.open(whatsappUrl, '_blank');
      
      setFormSuccess('✓ Thank you! WhatsApp has been opened with your enquiry details. Please review and send the message to complete your booking.');
      setFormData({
        fullName: '', company: '', email: '', phone: '',
        eventType: 'Royal Heritage Festia', preferredDate: '', requirements: ''
      });
      
    } catch (error) {
      console.error('Form submission error:', error);
      setFormError('Something went wrong. Please try again or contact us directly.');
    } finally {
      setFormLoading(false);
      setTimeout(() => {
        setFormSuccess('');
        setFormError('');
      }, 6000);
    }
  };

  const toggleFaq = (index) => setActiveFaq(activeFaq === index ? -1 : index);

  if (loading) {
    return (
      <>
        <Navbar />
        <div style={{ 
          display: 'flex', 
          justifyContent: 'center', 
          alignItems: 'center', 
          minHeight: '60vh',
          backgroundColor: '#f5f5f5'
        }}>
          <div className="spinner-border text-warning" style={{ width: '3rem', height: '3rem' }} role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
        <Footer />
      </>
    );
  }

  return (
    <>
      <Navbar />

      <style>{`
        /* Services Page Styles - Matching Home page structure */
        
        /* Main container matching Home page */
        body {
          margin: 0px !important;
          padding: 0px !important;
        }
        .services-main-container {
          background: #f5f5f5;
          margin: 0 auto;
          width: 100%;
          max-width: 100%;
          padding: 0px 20px;
          border: none;
          border-radius: 0px;
          box-shadow: none;
          margin-top: 0 !important;
          border-left: 29.5px solid #000 !important;
          border-right: 29.5px solid #000 !important;
          box-sizing: border-box;
        }

        @media (max-width: 1199px) and (min-width: 769px) {
          .services-main-container {
            border-left: 19.5px solid #000 !important;
            border-right: 19.5px solid #000 !important;
          }
        }
        
        @media (max-width: 768px) {
          .services-main-container {
            border-left: 17.5px solid #000 !important;
            border-right: 17.5px solid #000 !important;
            padding: 12px;
          }
        }

        /* Section Headers */
        .services-main-container .section-header {
          text-align: center;
          margin-bottom: 2.5rem;
          padding: 0 1rem;
        }
        
        .services-main-container .section-header h2 {
          font-family: 'Cinzel', serif;
          font-size: clamp(1.5rem, 5vw, 2rem);
          font-weight: 700;
          color: #000;
          margin-bottom: 0.75rem;
        }
        
        .services-main-container .section-header p {
          color: #666;
          font-size: clamp(0.85rem, 3vw, 0.95rem);
          max-width: 600px;
          margin: 0 auto;
        }
        
        .services-main-container .section-tag {
          color: #b8860b;
          font-size: clamp(0.7rem, 2.5vw, 0.8rem);
          letter-spacing: 2px;
          text-transform: uppercase;
          display: inline-block;
          margin-bottom: 0.5rem;
        }

        /* Hero Section */
        .services-main-container .services-hero {
          padding: clamp(2rem, 8vw, 4rem) clamp(1rem, 4vw, 2rem);
          background: linear-gradient(rgba(0,0,0,0.65), rgba(0,0,0,0.65)), url('https://images.unsplash.com/photo-1536392706976-e486e2ba97af?q=80&w=2000&auto=format');
          background-size: cover;
          background-position: center;
          text-align: center;
          margin-bottom: 2rem;
          border-radius: 16px;
        }
        
        .services-main-container .services-hero h1 {
          font-family: 'Cinzel', serif;
          font-size: clamp(1.8rem, 7vw, 3rem);
          font-weight: 700;
          color: #fff;
          margin-bottom: 1rem;
        }
        
        .services-main-container .services-hero p {
          font-size: clamp(0.9rem, 3.5vw, 1.1rem);
          color: rgba(255,255,255,0.9);
          max-width: 700px;
          margin: 0 auto;
        }
        
        .services-main-container .btn-accent,
        .services-main-container .btn-gold {
          background: #b8860b;
          color: #fff;
          border: none;
          padding: 0.75rem 1.5rem;
          border-radius: 50px;
          font-weight: 500;
          cursor: pointer;
          transition: 0.3s;
          display: inline-block;
          text-decoration: none;
          font-size: clamp(0.85rem, 3vw, 1rem);
        }
        
        .services-main-container .btn-accent:hover,
        .services-main-container .btn-gold:hover {
          background: #9b6e09;
          transform: translateY(-2px);
        }

        /* Service Cards - Desktop Grid, Mobile Horizontal Scroll */
        .services-main-container .services-row {
          display: flex;
          flex-wrap: wrap;
          margin: 0 -0.75rem;
        }
        
        @media (max-width: 768px) {
          .services-main-container .services-row {
            display: flex;
            flex-wrap: nowrap;
            overflow-x: auto;
            gap: 20px;
            padding-bottom: 20px;
            -webkit-overflow-scrolling: touch;
            margin: 0;
            scrollbar-width: none;
            -ms-overflow-style: none;
          }
          .services-main-container .services-row::-webkit-scrollbar {
            display: none;
          }
          .services-main-container .service-col {
            flex: 0 0 280px !important;
            max-width: 280px !important;
            padding: 0 !important;
          }
        }
        
        .services-main-container .service-card {
          background: #fff;
          border-radius: 12px;
          overflow: hidden;
          box-shadow: 0 3px 15px rgba(0,0,0,0.08);
          transition: 0.3s;
          height: 100%;
          cursor: pointer;
        }
        
        .services-main-container .service-card:hover {
          transform: translateY(-5px);
          box-shadow: 0 10px 30px rgba(184,134,11,0.25);
        }
        
        .services-main-container .service-img {
          height: clamp(180px, 30vw, 220px);
          overflow: hidden;
        }
        
        .services-main-container .service-img img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          transition: 0.4s;
        }
        
        .services-main-container .service-card:hover .service-img img {
          transform: scale(1.05);
        }
        
        .services-main-container .service-content {
          padding: clamp(1rem, 4vw, 1.5rem);
        }
        
        .services-main-container .service-content h3 {
          font-family: 'Cinzel', serif;
          font-size: clamp(1rem, 4vw, 1.3rem);
          font-weight: 700;
          margin-bottom: 0.75rem;
          color: #000;
        }
        
        .services-main-container .service-content p {
          color: #666;
          font-size: clamp(0.75rem, 2.8vw, 0.85rem);
          line-height: 1.5;
          margin-bottom: 1rem;
        }
        
        .services-main-container .feature-list {
          list-style: none;
          padding: 0;
        }
        
        .services-main-container .feature-list li {
          padding: 0.35rem 0;
          display: flex;
          align-items: center;
          gap: 0.5rem;
          color: #666;
          font-size: clamp(0.7rem, 2.5vw, 0.8rem);
          border-bottom: 1px dashed #eee;
        }
        
        .services-main-container .feature-list li i {
          color: #b8860b;
          font-size: clamp(0.7rem, 2.5vw, 0.75rem);
          flex-shrink: 0;
        }

        /* Why Choose Us Cards - Mobile Horizontal Scroll */
        .services-main-container .why-row {
          display: flex;
          flex-wrap: wrap;
          margin: 0 -0.75rem;
        }
        
        @media (max-width: 768px) {
          .services-main-container .why-row {
            display: flex;
            flex-wrap: nowrap;
            overflow-x: auto;
            gap: 20px;
            padding-bottom: 20px;
            -webkit-overflow-scrolling: touch;
            margin: 0;
            scrollbar-width: none;
            -ms-overflow-style: none;
          }
          .services-main-container .why-row::-webkit-scrollbar {
            display: none;
          }
          .services-main-container .why-col {
            flex: 0 0 240px !important;
            max-width: 240px !important;
            padding: 0 !important;
          }
        }
        
        .services-main-container .why-card {
          background: #fff;
          padding: clamp(1rem, 4vw, 1.5rem);
          border-radius: 12px;
          text-align: center;
          box-shadow: 0 3px 15px rgba(0,0,0,0.05);
          transition: 0.3s;
          height: 100%;
        }
        
        .services-main-container .why-card:hover {
          transform: translateY(-3px);
          box-shadow: 0 8px 25px rgba(184,134,11,0.1);
        }
        
        .services-main-container .why-icon {
          width: clamp(50px, 10vw, 60px);
          height: clamp(50px, 10vw, 60px);
          background: rgba(184,134,11,0.1);
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 0 auto;
        }
        
        .services-main-container .why-icon i {
          font-size: clamp(1.3rem, 4vw, 1.6rem);
          color: #b8860b;
        }
        
        .services-main-container .why-card h4 {
          font-family: 'Cinzel', serif;
          font-size: clamp(0.85rem, 3vw, 1rem);
          font-weight: 700;
          margin: 1rem 0 0.5rem;
          color: #000;
        }
        
        .services-main-container .why-card p {
          color: #666;
          font-size: clamp(0.7rem, 2.5vw, 0.8rem);
        }

        /* Supporting Services - Mobile Horizontal Scroll */
        .services-main-container .support-row {
          display: flex;
          flex-wrap: wrap;
          margin: 0 -0.75rem;
        }
        
        @media (max-width: 768px) {
          .services-main-container .support-row {
            display: flex;
            flex-wrap: nowrap;
            overflow-x: auto;
            gap: 15px;
            padding-bottom: 20px;
            -webkit-overflow-scrolling: touch;
            margin: 0;
            scrollbar-width: none;
            -ms-overflow-style: none;
          }
          .services-main-container .support-row::-webkit-scrollbar {
            display: none;
          }
          .services-main-container .support-col {
            flex: 0 0 200px !important;
            max-width: 200px !important;
            padding: 0 !important;
          }
        }
        
        .services-main-container .support-card {
          background: #fff;
          padding: clamp(0.8rem, 3vw, 1.2rem);
          border-radius: 10px;
          text-align: center;
          box-shadow: 0 2px 10px rgba(0,0,0,0.05);
          transition: 0.3s;
          height: 100%;
        }
        
        .services-main-container .support-card:hover {
          transform: translateY(-3px);
          box-shadow: 0 5px 20px rgba(184,134,11,0.1);
        }
        
        .services-main-container .support-icon {
          width: clamp(40px, 8vw, 50px);
          height: clamp(40px, 8vw, 50px);
          background: rgba(184,134,11,0.1);
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 0 auto 0.8rem;
        }
        
        .services-main-container .support-icon i {
          font-size: clamp(1rem, 3vw, 1.3rem);
          color: #b8860b;
        }
        
        .services-main-container .support-card h4 {
          font-family: 'Cinzel', serif;
          font-size: clamp(0.85rem, 2.8vw, 0.95rem);
          font-weight: 700;
          margin-bottom: 0.5rem;
          color: #000;
        }
        
        .services-main-container .support-card p {
          color: #666;
          font-size: clamp(0.7rem, 2.5vw, 0.75rem);
          line-height: 1.4;
        }

        /* Process Steps - Mobile Horizontal Scroll */
        .services-main-container .process-row {
          display: flex;
          flex-wrap: wrap;
          margin: 0 -0.75rem;
        }
        
        @media (max-width: 768px) {
          .services-main-container .process-row {
            display: flex;
            flex-wrap: nowrap;
            overflow-x: auto;
            gap: 20px;
            padding-bottom: 20px;
            -webkit-overflow-scrolling: touch;
            margin: 0;
            scrollbar-width: none;
            -ms-overflow-style: none;
          }
          .services-main-container .process-row::-webkit-scrollbar {
            display: none;
          }
          .services-main-container .process-col {
            flex: 0 0 200px !important;
            max-width: 200px !important;
            padding: 0 !important;
          }
        }
        
        .services-main-container .process-step {
          background: #fff;
          padding: clamp(0.8rem, 3vw, 1.2rem);
          border-radius: 12px;
          text-align: center;
          box-shadow: 0 2px 10px rgba(0,0,0,0.05);
          transition: 0.3s;
          height: 100%;
        }
        
        .services-main-container .step-number {
          width: clamp(35px, 8vw, 40px);
          height: clamp(35px, 8vw, 40px);
          background: #b8860b;
          color: #fff;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: clamp(0.9rem, 3vw, 1.1rem);
          font-weight: 700;
          margin: 0 auto 0.8rem;
        }
        
        .services-main-container .process-icon i {
          font-size: clamp(1rem, 3.5vw, 1.3rem);
          color: #b8860b;
        }
        
        .services-main-container .process-step h4 {
          font-family: 'Cinzel', serif;
          font-size: clamp(0.85rem, 2.8vw, 0.95rem);
          font-weight: 700;
          margin: 0.6rem 0 0.3rem;
          color: #000;
        }
        
        .services-main-container .process-step p {
          color: #666;
          font-size: clamp(0.7rem, 2.5vw, 0.75rem);
        }

        /* Testimonials - Mobile Horizontal Scroll */
        .services-main-container .testimonial-row {
          display: flex;
          flex-wrap: wrap;
          margin: 0 -0.75rem;
        }
        
        @media (max-width: 768px) {
          .services-main-container .testimonial-row {
            display: flex;
            flex-wrap: nowrap;
            overflow-x: auto;
            gap: 20px;
            padding-bottom: 20px;
            -webkit-overflow-scrolling: touch;
            margin: 0;
            scrollbar-width: none;
            -ms-overflow-style: none;
          }
          .services-main-container .testimonial-row::-webkit-scrollbar {
            display: none;
          }
          .services-main-container .testimonial-col {
            flex: 0 0 280px !important;
            max-width: 280px !important;
            padding: 0 !important;
          }
        }
        
        .services-main-container .testimonial-card {
          background: #fff;
          padding: clamp(1rem, 4vw, 1.5rem);
          border-radius: 12px;
          box-shadow: 0 3px 15px rgba(0,0,0,0.05);
          transition: 0.3s;
          height: 100%;
        }
        
        .services-main-container .testimonial-card:hover {
          transform: translateY(-3px);
          box-shadow: 0 8px 25px rgba(184,134,11,0.1);
        }
        
        .services-main-container .testimonial-rating i {
          color: #fbbf24;
          font-size: clamp(0.7rem, 2.5vw, 0.8rem);
          margin-right: 0.2rem;
        }
        
        .services-main-container .testimonial-text {
          color: #666;
          font-size: clamp(0.8rem, 2.8vw, 0.85rem);
          line-height: 1.6;
          margin: 1rem 0;
          font-style: italic;
        }
        
        .services-main-container .testimonial-author {
          display: flex;
          align-items: center;
          gap: 0.8rem;
          margin-top: 1rem;
          padding-top: 1rem;
          border-top: 1px solid #eee;
          flex-wrap: wrap;
        }
        
        .services-main-container .testimonial-author img {
          width: clamp(40px, 8vw, 45px);
          height: clamp(40px, 8vw, 45px);
          border-radius: 50%;
          object-fit: cover;
          border: 2px solid #b8860b;
        }
        
        .services-main-container .testimonial-author h5 {
          font-size: clamp(0.85rem, 2.8vw, 0.9rem);
          font-weight: 700;
          margin-bottom: 0.2rem;
          color: #000;
        }
        
        .services-main-container .testimonial-author span {
          font-size: clamp(0.65rem, 2.5vw, 0.7rem);
          color: #b8860b;
        }

        /* FAQ Section */
        .services-main-container .faq-section {
          background: #000;
          padding: clamp(2rem, 6vw, 3rem) 0;
          border-radius: 16px;
          margin: 20px 0;
        }
        
        .services-main-container .faq-section .section-header h2 {
          color: #fff;
        }
        
        .services-main-container .faq-section .section-header p {
          color: #aaa;
        }
        
        .services-main-container .accordion-item {
          background: #fff;
          border-radius: 10px;
          margin-bottom: 1rem;
          overflow: hidden;
        }
        
        .services-main-container .accordion-button {
          width: 100%;
          padding: clamp(0.8rem, 3vw, 1rem);
          background: #fff;
          border: none;
          text-align: left;
          font-weight: 600;
          font-size: clamp(0.85rem, 2.8vw, 0.9rem);
          cursor: pointer;
          transition: 0.3s;
          color: #000;
        }
        
        .services-main-container .accordion-button.active {
          background: #b8860b;
          color: #fff;
        }
        
        .services-main-container .accordion-content {
          padding: clamp(0.8rem, 3vw, 1rem);
          background: #fff;
          color: #666;
          font-size: clamp(0.8rem, 2.8vw, 0.85rem);
          border-top: 1px solid #eee;
        }

        /* Booking Form - Matching Home page */
        .services-main-container .booking-section {
          background: #fff;
          padding: 50px 0;
          margin: 20px 0;
          border-radius: 15px;
          box-shadow: 0 5px 20px rgba(0,0,0,0.05);
        }
        
        .services-main-container .booking-card {
          max-width: 900px;
          margin: 0 auto;
          padding: 30px;
        }
        
        .services-main-container .booking-form {
          display: flex;
          flex-direction: column;
          gap: 20px;
        }
        
        .services-main-container .form-row {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 20px;
        }
        
        .services-main-container .form-group {
          display: flex;
          flex-direction: column;
          gap: 8px;
        }
        
        .services-main-container .form-group.full-width {
          grid-column: span 2;
        }
        
        .services-main-container .form-label {
          font-weight: 500;
          color: #333;
          font-size: 13px;
        }
        
        .services-main-container .form-control,
        .services-main-container .form-select {
          width: 100%;
          padding: 12px 15px;
          border: 1px solid #ddd;
          border-radius: 8px;
          font-family: 'Montserrat', sans-serif;
          font-size: 13px;
          transition: 0.3s;
        }
        
        .services-main-container .form-control:focus,
        .services-main-container .form-select:focus {
          border-color: #b8860b;
          outline: none;
          box-shadow: 0 0 0 2px rgba(184,134,11,0.1);
        }
        
        .services-main-container textarea.form-control {
          resize: vertical;
        }
        
        .services-main-container .alert-success {
          background: #d4edda;
          color: #155724;
          padding: 12px;
          border-radius: 8px;
          margin-bottom: 20px;
          font-size: 13px;
        }
        
        .services-main-container .alert-danger {
          background: #f8d7da;
          color: #721c24;
          padding: 12px;
          border-radius: 8px;
          margin-bottom: 20px;
          font-size: 13px;
        }
        
        .services-main-container .btn-submit {
          background: #b8860b;
          color: #fff;
          border: none;
          padding: 14px 30px;
          border-radius: 40px;
          font-weight: 600;
          font-size: 14px;
          cursor: pointer;
          transition: 0.3s;
          display: inline-flex;
          align-items: center;
          gap: 10px;
          margin-top: 10px;
        }
        
        .services-main-container .btn-submit:hover {
          background: #9b6e09;
          transform: translateY(-2px);
        }
        
        .services-main-container .btn-submit:disabled {
          opacity: 0.7;
          cursor: not-allowed;
        }

        /* Container and Grid - Scoped */
        .services-main-container .container {
          max-width: 1200px;
          margin: 0 auto;
          padding: 0 1rem;
        }
        
        .services-main-container .row {
          display: flex;
          flex-wrap: wrap;
          margin: 0 -0.75rem;
        }
        
        .services-main-container [class*="col-"] {
          padding: 0 0.75rem;
          margin-bottom: 1.5rem;
        }
        
        .services-main-container .col-12 { flex: 0 0 100%; max-width: 100%; }
        .services-main-container .col-6 { flex: 0 0 50%; max-width: 50%; }
        
        @media (min-width: 576px) {
          .services-main-container .col-sm-6 { flex: 0 0 50%; max-width: 50%; }
        }
        
        @media (min-width: 768px) {
          .services-main-container .col-md-3 { flex: 0 0 25%; max-width: 25%; }
          .services-main-container .col-md-4 { flex: 0 0 33.333%; max-width: 33.333%; }
          .services-main-container .col-md-6 { flex: 0 0 50%; max-width: 50%; }
          .services-main-container .col-md-2-4 { flex: 0 0 20%; max-width: 20%; }
        }
        
        @media (min-width: 992px) {
          .services-main-container .col-lg-2 { flex: 0 0 16.666%; max-width: 16.666%; }
          .services-main-container .col-lg-4 { flex: 0 0 33.333%; max-width: 33.333%; }
          .services-main-container .col-lg-8 { flex: 0 0 66.666%; max-width: 66.666%; }
        }
        
        @media (max-width: 767px) {
          .services-main-container [class*="col-"] {
            flex: 0 0 100%;
            max-width: 100%;
            margin-bottom: 1rem;
          }
          
          .services-main-container .container {
            padding: 0 0.75rem;
          }
          
          .services-main-container .row {
            margin: 0;
          }
          
          .services-main-container [class*="col-"] {
            padding: 0;
          }
          
          .services-main-container .form-row {
            grid-template-columns: 1fr;
          }
          
          .services-main-container .form-group.full-width {
            grid-column: span 1;
          }
        }

        .services-main-container .py-3 { padding-top: 1.5rem; padding-bottom: 1.5rem; }
        .services-main-container .py-4 { padding-top: 2rem; padding-bottom: 2rem; }
        .services-main-container .py-5 { padding-top: clamp(2rem, 6vw, 2.5rem); padding-bottom: clamp(2rem, 6vw, 2.5rem); }
        .services-main-container .mt-3 { margin-top: 1rem; }
        .services-main-container .mb-4 { margin-bottom: 1.5rem; }
        .services-main-container .text-center { text-align: center; }
        .services-main-container .bg-light { background: #f5f5f5; }

        /* Floating Buttons - Matching Home page */
        .floating-buttons {
          position: fixed;
          bottom: 20px;
          right: 20px;
          display: flex;
          flex-direction: column;
          gap: 10px;
          z-index: 1000;
          opacity: 0;
          visibility: hidden;
          transform: translateY(20px);
          transition: 0.3s;
        }
        
        .floating-buttons.show {
          opacity: 1;
          visibility: visible;
          transform: translateY(0);
        }
        
        .floating-btn {
          width: 45px;
          height: 45px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          transition: 0.3s;
          border: none;
          box-shadow: 0 2px 10px rgba(0,0,0,0.2);
        }
        
        .floating-btn.whatsapp { background: #25d366; color: #fff; }
        .floating-btn.home { background: #b8860b; color: #fff; }
        .floating-btn.top { background: #b8860b; color: #fff; }
        .floating-btn:hover { transform: scale(1.1); }
        
        .back-to-top {
          position: fixed;
          bottom: 20px;
          right: 20px;
          width: 45px;
          height: 45px;
          background: #b8860b;
          color: #fff;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          opacity: 0;
          visibility: hidden;
          transition: 0.2s;
          z-index: 99;
          box-shadow: 0 2px 10px rgba(0,0,0,0.2);
        }
        
        .back-to-top.show {
          opacity: 1;
          visibility: visible;
        }

        /* Responsive adjustments */
        @media (max-width: 768px) {
          .floating-buttons {
            bottom: 15px;
            right: 15px;
            gap: 8px;
          }
          
          .floating-btn {
            width: 40px;
            height: 40px;
          }
          
          .back-to-top {
            width: 40px;
            height: 40px;
            bottom: 15px;
            right: 15px;
          }
          
          .services-main-container .booking-card {
            padding: 20px;
          }
        }
        
        @media (max-width: 576px) {
          .services-main-container .booking-card {
            padding: 1rem;
          }
        }
      `}</style>

      <div className="services-main-container">
        {/* Hero Section */}
        <div className="services-hero">
          <div className="container">
            <h1>{content.hero?.title || 'Our Royal Services'}</h1>
            <p>{content.hero?.subtitle || 'Experience the epitome of elegance with our signature royal experiences'}</p>
            <div className="mt-3">
              <a href="#booking" className="btn-accent">{content.hero?.button_text || 'Plan Your Royal Event'}</a>
            </div>
          </div>
        </div>

        {/* Main Services - Clickable Cards with Horizontal Scroll on Mobile */}
        <div className="py-5">
          <div className="container">
            <div className="section-header">
              <span className="section-tag">✦ SIGNATURE EXPERIENCES</span>
              <h2>{content.services_section?.title || 'Our Premier Services'}</h2>
              <p>{content.services_section?.subtitle || 'Exquisite offerings that define royal elegance'}</p>
            </div>
            <div className="services-row">
              {services.map((service, idx) => (
                <div className="service-col col-md-4 col-sm-6 col-12" key={idx}>
                  <div className="service-card" onClick={() => handleServiceClick(service.path)}>
                    <div className="service-img">
                      <img src={service.image} alt={service.title} />
                    </div>
                    <div className="service-content">
                      <h3>{service.title}</h3>
                      <p>{service.description}</p>
                      <ul className="feature-list">
                        {service.features.map((feature, i) => (
                          <li key={i}><i className="bi bi-check-circle-fill"></i> {feature}</li>
                        ))}
                      </ul>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Why Choose Us with Horizontal Scroll on Mobile */}
        <div className="py-5 bg-light">
          <div className="container">
            <div className="section-header">
              <span className="section-tag">✦ WHY CHOOSE US</span>
              <h2>{content.why_choose_us?.title || 'The Royal Heritage Advantage'}</h2>
              <p>{content.why_choose_us?.subtitle || 'What makes us the premier choice for royal celebrations'}</p>
            </div>
            <div className="why-row">
              {whyChooseUs.map((item, idx) => (
                <div className="why-col col-md-3 col-sm-6 col-12" key={idx}>
                  <div className="why-card">
                    <div className="why-icon"><i className={`bi ${item.icon}`}></i></div>
                    <h4>{item.title}</h4>
                    <p>{item.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Supporting Services with Horizontal Scroll on Mobile */}
        <div className="py-5">
          <div className="container">
            <div className="section-header">
              <span className="section-tag">✦ ADDITIONAL OFFERINGS</span>
              <h2>{content.supporting_services?.title || 'Supporting Services'}</h2>
              <p>{content.supporting_services?.subtitle || 'Complete solutions for your royal celebration'}</p>
            </div>
            <div className="support-row">
              {supportingServices.map((service, idx) => (
                <div className="support-col col-lg-2 col-md-4 col-sm-6 col-12" key={idx}>
                  <div className="support-card">
                    <div className="support-icon"><i className={`bi ${service.icon}`}></i></div>
                    <h4>{service.title}</h4>
                    <p>{service.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Our Process with Horizontal Scroll on Mobile */}
        <div className="py-5 bg-light">
          <div className="container">
            <div className="section-header">
              <span className="section-tag">✦ HOW WE WORK</span>
              <h2>{content.our_process?.title || 'Our Royal Process'}</h2>
              <p>{content.our_process?.subtitle || 'A meticulous approach to crafting unforgettable experiences'}</p>
            </div>
            <div className="process-row">
              {processItems.map((step, idx) => (
                <div className="process-col col-md-2-4 col-sm-6 col-12" key={idx}>
                  <div className="process-step">
                    <div className="step-number">{step.num}</div>
                    <div className="process-icon"><i className={`bi ${step.icon}`}></i></div>
                    <h4>{step.title}</h4>
                    <p>{step.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Testimonials with Horizontal Scroll on Mobile */}
        <div className="py-5">
          <div className="container">
            <div className="section-header">
              <span className="section-tag">✦ ROYAL FEEDBACK</span>
              <h2>{content.testimonials?.title || 'What Our Guests Say'}</h2>
              <p>{content.testimonials?.subtitle || 'Experiences that speak for themselves'}</p>
            </div>
            <div className="testimonial-row">
              {testimonialItems.map((testimonial, idx) => (
                <div className="testimonial-col col-lg-4 col-md-12" key={idx}>
                  <div className="testimonial-card">
                    <div className="testimonial-rating">
                      {[...Array(testimonial.rating || 5)].map((_, i) => <i key={i} className="bi bi-star-fill"></i>)}
                    </div>
                    <p className="testimonial-text">"{testimonial.text}"</p>
                    <div className="testimonial-author">
                      <img src={testimonial.img} alt={testimonial.name} />
                      <div>
                        <h5>{testimonial.name}</h5>
                        <span>{testimonial.title}</span>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* FAQ Section */}
        <div className="faq-section">
          <div className="container">
            <div className="section-header">
              <span className="section-tag">✦ FAQ</span>
              <h2>{content.faq?.title || 'Frequently Asked Questions'}</h2>
              <p>{content.faq?.subtitle || 'Quick answers about our royal services'}</p>
            </div>
            <div className="row justify-content-center">
              <div className="col-lg-8 col-12">
                {faqItems.map((faq, idx) => (
                  <div className="accordion-item" key={idx}>
                    <button className={`accordion-button ${activeFaq === idx ? 'active' : ''}`} onClick={() => toggleFaq(idx)}>
                      {faq.question}
                    </button>
                    {activeFaq === idx && (
                      <div className="accordion-content">{faq.answer}</div>
                    )}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* Booking Form - Matching Home page structure */}
        <div className="booking-section" id="booking">
          <div className="booking-card">
            <div className="section-header" style={{ marginTop: 0 }}>
              <span className="section-tag">✦ PLAN YOUR ROYAL EVENT</span>
              <h2>{content.booking?.title || "Let's Create Your Royal Experience"}</h2>
              <p>{content.booking?.subtitle || 'Share your vision and we\'ll bring it to life'}</p>
            </div>
            
            {formSuccess && <div className="alert-success">{formSuccess}</div>}
            {formError && <div className="alert-danger">{formError}</div>}
            
            <form className="booking-form" onSubmit={handleFormSubmit}>
              <div className="form-row">
                <div className="form-group">
                  <label className="form-label">Full Name *</label>
                  <input type="text" className="form-control" name="fullName" value={formData.fullName} onChange={handleInputChange} placeholder="Enter your full name" required />
                </div>
                <div className="form-group">
                  <label className="form-label">Company / Organization</label>
                  <input type="text" className="form-control" name="company" value={formData.company} onChange={handleInputChange} placeholder="Your company name" />
                </div>
              </div>
              
              <div className="form-row">
                <div className="form-group">
                  <label className="form-label">Email Address *</label>
                  <input type="email" className="form-control" name="email" value={formData.email} onChange={handleInputChange} placeholder="you@example.com" required />
                </div>
                <div className="form-group">
                  <label className="form-label">Phone Number</label>
                  <input type="tel" className="form-control" name="phone" value={formData.phone} onChange={handleInputChange} placeholder="+91 98765 43210" />
                </div>
              </div>
              
              <div className="form-row">
                <div className="form-group">
                  <label className="form-label">Event Type *</label>
                  <select className="form-select" name="eventType" value={formData.eventType} onChange={handleInputChange} required>
                    <option>Royal Heritage Festia</option>
                    <option>Royal Dinners</option>
                    <option>Music & Concerts</option>
                  </select>
                </div>
                <div className="form-group">
                  <label className="form-label">Preferred Date *</label>
                  <input type="date" className="form-control" name="preferredDate" value={formData.preferredDate} onChange={handleInputChange} min={new Date().toISOString().split('T')[0]} required />
                </div>
              </div>
              
              <div className="form-group full-width">
                <label className="form-label">Event Requirements *</label>
                <textarea className="form-control" name="requirements" rows="4" value={formData.requirements} onChange={handleInputChange} placeholder="Tell us about your vision, expected guests, special requests..." required></textarea>
              </div>
              
              <div className="form-submit">
                <button type="submit" className="btn-submit" disabled={formLoading}>
                  <i className="bi bi-whatsapp"></i> {formLoading ? 'Sending...' : (content.booking?.button_text || 'Send Enquiry via WhatsApp')}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>

      <Footer />

      {/* Floating Buttons - Matching Home page */}
      <div className={`floating-buttons ${showFloatingButtons ? 'show' : ''}`}>
        <button className="floating-btn home" onClick={handleHomeClick}><i className="bi bi-house-door-fill"></i></button>
        <button className="floating-btn whatsapp" onClick={handleWhatsAppClick}><i className="bi bi-whatsapp"></i></button>
        <button className="floating-btn top" onClick={handleBackToTop}><i className="bi bi-arrow-up"></i></button>
      </div>
      <div className={`back-to-top ${showBackToTop ? 'show' : ''}`} onClick={handleBackToTop}><i className="bi bi-arrow-up"></i></div>
    </>
  );
};

export default Services;